// Packages
import eases from 'eases';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/cases/case/index.scss';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';

// Blocks
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

//
// HEADER
//
import Header from '~scripts/blocks/header';

Header();

//
// NAVIGATION
//
import Navigation from '~scripts/blocks/navigation';

Navigation();

//
// FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

// Animation

const problemItems = document.querySelectorAll('.js-problems-list > li');
const featureItems = document.querySelectorAll('.js-feature');

problemItems.forEach((item) => {
  scrollAnimationProgress(
    item,
    {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        const height = el.offsetHeight;
        return rect.top + window.scrollY - (window.innerHeight + 80 - height / 2);
      },
      getEnd(el, start) {
        const height = el.offsetHeight;
        return start + height * 4;
      },
    },
    eases.cubicOut
  );
});

featureItems.forEach((item) => {
  scrollAnimationProgress(
    item,
    {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY - (window.innerHeight + 50);
      },
      getEnd(el, start) {
        return start + 200;
      },
    },
    eases.linear
  );
});
